export const getCurrentUser = (state) => state.entities.users.currentUser || {};
